<script lang="ts">
	import TailArrowLeft from '$lib/components/icon/TailArrowLeft.svelte';
	import { hideMenu } from '../../mypage/store';

	function toggleMenu() {
		hideMenu.update((value: any) => !value);
	}
</script>

<div class="flex flex-col w-full mobile-hide-footer">
	<div
		class="desktop:hidden flex justify-between w-full h-[68px] bg-red-delay-200 px-4 py-[22px] bg-white border-b-[1px] border-gray-100"
	>
		<button type="button" class="w-6 h-6" on:click={toggleMenu}>
			<TailArrowLeft color="#292929" size="24" /></button
		>
		<span class="leading-6 text-h4 text-basic-black-100"> 이메일무단수집거부 </span>
		<div class="w-6 h-6" />
	</div>
	<div class="items-center justify-between hidden w-full py-8 desktop:flex">
		<div class="text-[28px] font-semibold">이메일무단수집거부</div>
	</div>
	<div
		class="h-[calc(100vh-206px)] overflow-y-scroll desktop:h-fit desktop:overflow-visible flex flex-col px-4 py-6 space-y-4 desktop:pt-0 desktop:flex-row desktop:w-full desktop:flex-wrap desktop:gap-4 desktop:px-0 desktop:justify-between desktop:space-y-0"
	>
		본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치 를 이용하여
		무단으로 수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해 형사 처벌됨을 유념하시기
		바랍니다. <br />
		<br />
		정보통신망 이용촉진 및 정보보호 등에 관한 법률<br />
		<br />
		제50조의2 (전자우편주소의 무단 수집행위 등 금지)<br />
		<br />
		누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를
		수집 하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.
		<br />
		누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매ㆍ유통하여서는 아니된다.
		<br />
		누구든지 제1항 및 제2항의 규정에 의하여 수집ㆍ판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보
		전송에 이용하여서는 아니된다.
		<br />
		<br />
		<br />
		<br />
		<br />
	</div>
</div>

<style lang="postcss">
	table {
		@apply border-[1px] border-black;
	}
	th,
	td {
		@apply border-[1px] border-black px-2 text-center py-2;
	}
</style>
